import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./EditProfileModal.css";
import { toast } from "react-toastify";
import { UsuarioService } from "../../services/UsuarioService";

const EditProfileModal = ({ open, onClose, user, onUpdate, token }) => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
    celular: "",
    password: "",
    confirmPassword: "",
    direccion: ""
  });

  const [datosBasicos, setDatosBasicos] = useState({
    email: "",
    celular: "",
    password: "",
    confirmPassword: "",
    direccion: "",
  });

  useEffect(() => {
    if (open && user) {
      fetchUserData();
    }
  }, [open, user]);

  const handleDatosBasicosChange = (e) => {
    const { name, value } = e.target;
    setDatosBasicos((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchUserData = async () => {
    try {
      const token = localStorage.getItem("token");
      const user = await UsuarioService.obtenerDatosPersonales(token);

      setDatosBasicos({
        email: user.email ?? "",
        celular: user.celular ?? "",
        password: "",
        confirmPassword: "",
        direccion: user.direccion ?? "",
      });
    } catch (error) {
      console.error("Error al obtener datos del usuario:", error);
    }
  };

  const handleSaveDatosBasicos = async () => {
    setLoading(true);
    const newErrors = {};

    if (!datosBasicos.email.includes("@")) {
      newErrors.email = "Correo inválido";
    }

    if (!datosBasicos.celular.trim()) {
      newErrors.celular = "El celular es obligatorio";
    }

    if (datosBasicos.newPassword && datosBasicos.newPassword.length < 6) {
      newErrors.newPassword = "La contraseña debe tener al menos 6 caracteres";
    }

    if (datosBasicos.newPassword && datosBasicos.newPassword !== datosBasicos.confirmPassword) {
      newErrors.confirmPassword = "Las contraseñas no coinciden";
    }

    if (!datosBasicos.direccion.trim()) {
      newErrors.direccion = "La dirección es obligatoria";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setLoading(false); // Asegúrate de detener el loading si hay errores
      return;
    }

    try {
      const updateData = {
        email: datosBasicos.email,
        celular: datosBasicos.celular,
        direccion: datosBasicos.direccion,
        newPassword: datosBasicos.newPassword || undefined,
      };

       await UsuarioService.actualizarDatosBasicos({
        token,
        userId: user.id,
        updateData,
      });

      toast.success("Datos básicos actualizados correctamente");

      onUpdate({ ...user, ...updateData });

      setDatosBasicos((prev) => ({
        ...prev,
        password: "",
        confirmPassword: "",
      }));
    } catch (err) {
      console.error("❌ Error al actualizar datos básicos:", err);
      toast.error("Hubo un error al actualizar los datos");
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <div className="modal-header">
          <h2>Editar Perfil</h2>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-content">
          <div className="datos-basicos-form">
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  name="email"
                  value={datosBasicos.email}
                  onChange={handleDatosBasicosChange}
                  placeholder="Ingrese su email"
                  readOnly
                />
                {errors.email && <span className="error">{errors.email}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="celular">Celular:</label>
                <input
                  type="text"
                  name="celular"
                  value={datosBasicos.celular}
                  onChange={handleDatosBasicosChange}
                  placeholder="Ingrese su celular"
                />
                {errors.celular && <span className="error">{errors.celular}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="newPassword">Nueva Contraseña:</label>
                <input
                  type="password"
                  name="newPassword"
                  value={datosBasicos.newPassword}
                  onChange={handleDatosBasicosChange}
                  placeholder="Dejar vacío para no cambiar"
                />
                {errors.newPassword && <span className="error">{errors.newPassword}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">Confirmar Contraseña:</label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={datosBasicos.confirmPassword}
                  onChange={handleDatosBasicosChange}
                  placeholder="Confirmar nueva contraseña"
                />
                {errors.confirmPassword && <span className="error">{errors.confirmPassword}</span>}
              </div>
              <div className="form-group">
                <label htmlFor="direccion">Dirección:</label>
                <input
                  type="text"
                  name="direccion"
                  value={datosBasicos.direccion}
                  onChange={handleDatosBasicosChange}
                  placeholder="Ingrese su dirección"
                />
                {errors.direccion && <span className="error">{errors.direccion}</span>}
              </div>

              <div className="form-actions">
                <button
                  className="save-edit-btn"
                  onClick={handleSaveDatosBasicos}
                  disabled={loading}
                >
                  {loading ? "Guardando..." : "Actualizar"}
                </button>
              </div>
            </div>
        </div>
      </div>
    </div>
  );
};

EditProfileModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  user: PropTypes.object,
  onUpdate: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
};

export default EditProfileModal;
